import * as general from "../general";
import { SuccessReturnBody } from '../general';

export interface Scope3Data {
    AProd: number | null,
    AEdif: number | null,
    B: number | null,
    C: number | null,
    wasteImpact: number | null,
    businessTripImpact: number | null,
}

export function getScope3DataSuccess(scope3Data: Scope3Data): SuccessReturnBody {
    return general.getSuccessReturnBody(scope3Data); 
  }